

import React, { useEffect, useState } from "react";
import axios from "axios";
import Boxvalue from "../ReportTab/Boxvalue";
import Charts from "../ReportTab/Charts";
import LineCharts from "../ReportTab/LineCharts";
import heartLoading from "../../assests/heartLoading.gif";
import StackedParentDomainChart from "../ReportTab/StackedParentDomainChart";
import Tooltip from "@mui/material/Tooltip";



const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-holistic/overview";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const OverviewPage = ({ filters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product, startDate, endDate } = filters;

  const [metrics, setMetrics] = useState([]);
  const [dqKPIScores, setDqKPIScores] = useState([]);
  const [dqScoreTrendGraph, setDqScoreTrendGraph] = useState({});


  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [domainScore, setDomainScore] = useState({});


  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
        params: {
          parentDomain: Array.isArray(parentDomain) && parentDomain.length > 0 ? parentDomain.join(",") : "",
          domain: Array.isArray(domain) && domain.length > 0 ? domain.join(",") : "",
          subDomain: Array.isArray(subDomain) && subDomain.length > 0 ? subDomain.join(",") : "",
          product: Array.isArray(product) && product.length > 0 ? product.join(",") : "",
          start_date: startDate || undefined,
          end_date: endDate || undefined,
          page: DEFAULT_PAGE,
          pageSize: DEFAULT_PAGE_SIZE,
        },
      });

      setMetrics(res.data.metrics || []);
      setDqKPIScores(res.data.dqKPIScores || []);
      setDqScoreTrendGraph(res.data.dqScoreTrendGraph || {});
      setDomainScore(res.data.domain_Score || {});

      if (res.data.filters && res.data.filters.parent_domains) {
        if (typeof onFilterOptionsChange === "function") {
          onFilterOptionsChange(res.data.filters.parent_domains);
        }
      }
    } catch (err) {
      setError("Failed to fetch overview");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product, startDate, endDate]);



  if (loading) {
    return (
      <div
        className="flex items-center justify-center w-full overflow-hidden"
        style={{
          minHeight: "100%",
          marginTop: "80px",
        }}
      >
        <div className="text-center flex flex-col items-center justify-center space-y-4">
          <img src={heartLoading} alt="Loading..." style={{ width : 200}} />
          <div className="space-y-2">
            <p className="text-gray-700 text-xl font-semibold">
              Applying filters...
            </p>
            <p className="text-gray-500 text-base">
              Updating results based on your selection
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <>

      <div className="w-full bg-[#eee] py-6">
        <div className="w-[90%] mx-auto">
          <div className="flex gap-[8rem] items-stretch">
            <div className="basis-1/2 flex flex-col">
              <div className="flex-1 flex">
                <Boxvalue metrics={metrics} />
              </div>
            </div>

            <div className="basis-1/2 flex flex-col mt-[15px]">
              <div className="flex space-x-8 justify-around pb-2 mb-[3px]">
                {items.map((item, idx) => (
                  <div key={idx} className="flex items-center space-x-2">
                    <div
                      className="w-[14px] h-[50px] rounded-full"
                      style={{ backgroundColor: item.color.trim() }}
                    />
                    <div className="flex flex-col text-sm text-gray-500">
                      <span className="labeling-items">DQ KPI Score</span>
                      <span className="labeling-items">{item.label}</span>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex-1 mt-[10px]">
                <Charts dqKPIScores={dqKPIScores} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex gap-[10px] items-stretch mt-[1rem] h-[500px]">
        <div className="w-1/2 bg-[#eee]  pl-3 pr-3 pt-2 pb-4 rounded-2xl shadow">
          <LineCharts dqScoreTrendGraph={dqScoreTrendGraph} />
        </div>

        <div className="w-1/2 bg-[#eee] pl-3 pr-3 pt-3 pb-1 rounded-2xl shadow" style={{ overflowY: "auto" }}>
          <h3 className="text-lg font-semibold text-gray-700 mb-4 flex items-center gap-2">
            Domain Wise Quality Score
            <Tooltip
              arrow
              title={
                <div style={{ display: "flex", flexDirection: "column", gap: "6px", padding: "2px" }}>
                  {items.map((item, idx) => (
                    <div key={idx} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{
                        width: "10px", height: "10px",
                        borderRadius: "50%",
                        backgroundColor: item.color.trim(),
                        flexShrink: 0
                      }} />
                      <span>Domain Quality Score {item.label}</span>
                    </div>
                  ))}
                </div>
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16" height="16"
                viewBox="0 0 24 24"
                fill="none" stroke="#6B7280"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                style={{ cursor: "help" }}
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            </Tooltip>
          </h3>
          <StackedParentDomainChart domainScore={domainScore} />
        </div>

      </div>
    </>
  );
};

export default OverviewPage;
